// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1xqge","visuallyhidden":"ueb5b","hide-text":"yq7D8","center":"_3ymZs","noprint":"_2mZPj","listItem":"_1BRhu","authorList":"iYfdu","image":"_3eAqo","root":"x1bQz _25KE7","description":"_7gAe0"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-byline/styles/feature.scss
 ** module id = 131
 ** module chunks = 2
 **/